import type { AvailabilitySchedule, DayOfWeek, TimeSlot } from '../types/index';

// Helper function to convert availability schedule from backend format to frontend format
export const convertAvailabilityScheduleFromBackend = (schedule: any): AvailabilitySchedule | undefined => {
  if (!schedule || !schedule.schedule) return undefined;
  
  const convertedSchedule = schedule.schedule.map((day: any) => ({
    day: day.day as DayOfWeek,
    timeSlots: day.timeSlots as TimeSlot[]
  }));
  
  return {
    schedule: convertedSchedule
  };
};

// Helper function to convert availability schedule from frontend format to backend format
export const convertAvailabilityScheduleToBackend = (schedule: AvailabilitySchedule | undefined): any => {
  if (!schedule) return undefined;
  
  return {
    schedule: schedule.schedule.map(day => ({
      day: day.day,
      timeSlots: day.timeSlots
    }))
  };
}; 